import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { history } from "../store";
import AppHeader from "../containers/AppHeader";
import { withNamespaces } from "react-i18next";
import { fetchAvailability, postCancelPrebooking } from "../actions/qrs";
import NmStepBar from "../components/NmStepBar"
import { MapPin } from 'lucide-react';

class ZoneSelectorView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      zones: null,
      description: null,
      color: null,
      map: null,
      customerName: null,
      forwardScreen: false,
      machineSleeping: false,
    };

    this.toggle = this.toggle.bind(this);
    this.goTo = this.goTo.bind(this);
  }

  toggle() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  goTo(zoneNumber, descriptionZone) {
    const { id } = this.props.match.params;
    const { qrMode } = this.props.location.state;

    this.setState({ forwardScreen: true }, () => {
      history.push("/lockerSelectorView", {
        zoneSelected: zoneNumber,
        descriptionZone: descriptionZone,
        qr: id,
        customerName: this.state.customerName,
        qrMode: qrMode,
      });
    });
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    const navigationEntries = window.performance.getEntriesByType("navigation");
    if (
      navigationEntries.length > 0 &&
      navigationEntries[0].type === "reload"
    ) {
      console.log("Page was reloaded");
    }

    const now = new Date();
    const spainTime = new Intl.DateTimeFormat("en-US", {
      timeZone: "Europe/Madrid",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
    }).formatToParts(now);

    const hour = parseInt(
      spainTime.find((part) => part.type === "hour").value,
      10
    );

    if (hour === 23 || hour === 0) {
      this.setState({ machineSleeping: true });
      return;
    }

    this.props
      .fetchAvailability(id)
      .then((answer) => {
        const answerZones = answer.response.answerZones;

        if (answerZones.multipleZones) {
          this.setState({
            zones: answerZones.multipleZones,
            description: answerZones.descriptionZones,
            color: answerZones.colorZones,
            map: answerZones.mapZones,
            customerName: answerZones.customerName,
          });
        } else if (answerZones.singleZone) {
          this.setState({ customerName: answerZones.customerName }, () => {
            this.goTo(
              answerZones.singleZone,
              answerZones.descriptionZones[answerZones.singleZone - 1]
            );
          });
        } else {
          this.setState({ customerName: answerZones.customerName });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  renderZones() {
    const { t } = this.props;
    const { zones, description, color, map } = this.state;

    if (!zones || !description) {
      return (
        <div className="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    return (
      <div className="nm-zone-grid">
        {[...zones].sort((a, b) => a - b).map((zone) => {
          const bgColor = color ? color[zone - 1] : undefined;
          const zoneMapUrl = map ? map[zone - 1] : undefined;

          return (
            <div
              key={zone}
              className="nm-zone-card"
              onClick={() => this.goTo(zone, description[zone - 1])}
              style={bgColor ? { background: bgColor } : {}}
            >
              <div className="nm-zone-card-icon">
                <MapPin size={26} />
              </div>
              <div className="nm-zone-card-number">{t("ZONA ") + zone}</div>
              <div className="nm-zone-card-desc">{t(description[zone - 1])}</div>
              {zoneMapUrl && zoneMapUrl !== "https://vacway.com" && (
                <button
                  className="nm-zone-map-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(zoneMapUrl, "_blank");
                  }}
                >
                  {t("Mapa")} ↗
                </button>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  renderSleepingMessage() {
    const { t } = this.props;
    const { customerName } = this.state;

    return (
      <div className="normalBackground">
        <AppHeader />
        <div className="nm-page">
          <div className="nm-zone-header">
            <span className="nm-zone-header-badge">{t("BIENVENIDO A")}</span>
            <h1 className="nm-zone-header-name">{customerName}</h1>
          </div>
          <div className="nm-sleeping-msg">
            <h3 className="text-warning">{t("Fuera de horario")}</h3>
            <p>
              {t(
                "Lo sentimos, pero la venta no está disponible entre las 23:00h y la 01:00h, vuelva fuera de este horario."
              )}
            </p>
            <img
              src="/images/sleeping_machine.webp"
              alt="Sleeping Machine"
              className="nm-sleeping-img"
            />
          </div>
          <NmStepBar step={1} />
        </div>
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const { customerName, machineSleeping } = this.state;

    if (machineSleeping) {
      return this.renderSleepingMessage();
    }

    return (
      <div className="normalBackground">
        <AppHeader />
        <div className="nm-page">
          <div className="nm-zone-header">
            <span className="nm-zone-header-badge">{t("BIENVENIDO A")}</span>
            <h1 className="nm-zone-header-name">{customerName}</h1>
            <p className="nm-zone-header-sub">{t("SELECCIONA LA ZONA DE TAQUILLAS")}</p>
          </div>
          {this.renderZones()}
          <NmStepBar step={1} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: true,
  availability: state.availability,
});

const mapDispatchToProps = (dispatch) => ({
  push: bindActionCreators(push, dispatch),
  fetchAvailability: bindActionCreators(fetchAvailability, dispatch),
  postCancelPrebooking: bindActionCreators(postCancelPrebooking, dispatch),
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(ZoneSelectorView)
);
